import type { ProjectResponse } from '@/model/project/dto.generated';
import { signedOut } from '@/viewmodel/features/user';
import { clearCurrentWorkspace } from '@/viewmodel/features/workspace';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ProjectDataState {
  currentProject: ProjectResponse | undefined;
  pendingProjectId: string | undefined;
}

const initialState: ProjectDataState = {
  currentProject: undefined,
  pendingProjectId: undefined,
};

const projectSlice = createSlice({
  name: 'projectData',
  initialState,
  reducers: {
    setCurrentProject: (state, action: PayloadAction<ProjectResponse>) => {
      state.currentProject = action.payload;
    },
    clearCurrentProject: (state) => {
      state.currentProject = undefined;
    },
    setPendingProject: (state, action: PayloadAction<string>) => {
      state.pendingProjectId = action.payload;
    },
    clearPendingProject: (state) => {
      state.pendingProjectId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearCurrentWorkspace, (state) => {
      state.currentProject = undefined;
    });
    builder.addCase(signedOut, () => initialState);
  },
});

export const { setCurrentProject, clearCurrentProject, setPendingProject, clearPendingProject } =
  projectSlice.actions;
export default projectSlice.reducer;

type ProjectsRootState = { projects: ProjectDataState };

export const selectCurrentProject = (state: ProjectsRootState) => state.projects?.currentProject;
export const selectPendingProjectId = (state: ProjectsRootState) =>
  state.projects?.pendingProjectId;
